module.exports = __webpack_public_path__ + "img/6.b97388c5.png";